import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import { useAppDispatch } from "../../../app/store";
import { fetchSanctionEvents } from "../Logic/sanctionEventsThunk";
import { SanctionEventsTable } from "./SanctionEventsTable";

const SanctionEventsContainer: React.FC = () => {
    const { id: caseId } = useParams<{ id: string }>();
    const dispatch = useAppDispatch();

    useEffect(() => {
      if (!caseId) return;

      dispatch(fetchSanctionEvents(caseId));
    }, [caseId, dispatch]);

    if (!caseId) return null;

    return (
      <div className="mt-6 px-4 pb-4 min-w-0">
        <SanctionEventsTable />
      </div>
    );
};

export default SanctionEventsContainer;
